import React from 'react';

const Podium = ({ topPlayers, onPlayerClick, sortBy }) => {
    // Ensure we have 3 slots, filling with null if fewer players
    const podiumSlots = [
        topPlayers[1] || null, // 2nd Place (Left)
        topPlayers[0] || null, // 1st Place (Center)
        topPlayers[2] || null  // 3rd Place (Right)
    ];

    const getRankStyle = (index) => {
        // Index 0 in our array is 2nd place, Index 1 is 1st, Index 2 is 3rd
        if (index === 1) return {
            height: 'h-48 md:h-64',
            color: 'text-yellow-400',
            borderColor: 'border-yellow-400',
            gradient: 'from-yellow-400/20 to-transparent',
            avatarBg: 'bg-gradient-to-br from-yellow-300 to-amber-500',
            glow: 'shadow-[0_0_30px_rgba(250,204,21,0.3)]',
            rank: 1,
            icon: '👑'
        };
        if (index === 0) return {
            height: 'h-40 md:h-52',
            color: 'text-gray-300',
            borderColor: 'border-gray-300',
            gradient: 'from-gray-300/20 to-transparent',
            avatarBg: 'bg-gradient-to-br from-gray-200 to-gray-400',
            glow: 'shadow-[0_0_20px_rgba(209,213,219,0.2)]',
            rank: 2,
            icon: '🥈'
        };
        return {
            height: 'h-32 md:h-44',
            color: 'text-amber-700',
            borderColor: 'border-amber-700',
            gradient: 'from-amber-700/20 to-transparent',
            avatarBg: 'bg-gradient-to-br from-orange-300 to-amber-600',
            glow: 'shadow-[0_0_20px_rgba(180,83,9,0.2)]',
            rank: 3,
            icon: '🥉'
        };
    };

    return (
        <div className="flex justify-center items-end gap-2 md:gap-6 mb-8 px-4 pt-4">
            {podiumSlots.map((player, index) => {
                const style = getRankStyle(index);

                if (!player) {
                    return (
                        <div key={index} className={`w-1/3 max-w-[140px] flex flex-col items-center justify-end opacity-20`}>
                            <div className={`w-full ${style.height} rounded-t-2xl bg-white/5 border-t border-x border-white/10`} />
                        </div>
                    );
                }

                return (
                    <div
                        key={player.name}
                        onClick={() => onPlayerClick(player)}
                        className={`relative w-1/3 max-w-[140px] flex flex-col items-center cursor-pointer group z-10 ${index === 1 ? 'z-20 -mt-4' : ''}`}
                    >


                        {/* Podium Block */}
                        <div className={`w-full ${style.height} bg-gradient-to-b ${style.gradient} bg-[#1e293b]/80 backdrop-blur-md border-t border-x ${style.borderColor} rounded-t-2xl flex flex-col items-center justify-end pb-4 relative overflow-hidden group-hover:bg-[#1e293b] transition-colors`}>
                            {/* Shine Effect */}
                            <div className="absolute inset-0 bg-gradient-to-tr from-white/0 via-white/5 to-white/0 translate-y-full group-hover:-translate-y-full transition-transform duration-700" />

                            <div className="text-center px-1 z-10">
                                <p className={`font-black text-sm md:text-lg truncate max-w-full px-2 ${style.color}`}>
                                    {player.name}
                                </p>
                                <p className="text-[10px] md:text-xs text-gray-400 font-bold mt-1">
                                    {sortBy === 'winRate' ? `${player.winRate}% Win` :
                                        sortBy === 'highRisk' ? `${player.riskLevel}% Risk` :
                                            sortBy === 'sensible' ? `${100 - player.riskLevel}% Safety` :
                                                sortBy === 'luckiest' ? `${player.luckRating}% Luck` :
                                                    `${player.gamesPlayed} Games`}
                                </p>
                            </div>

                            <div className={`mt-2 text-3xl md:text-5xl font-black opacity-10 ${style.color}`}>
                                {style.rank}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default Podium;
